import axios from 'axios';

// Configuración base para el servicio de habitaciones
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

const roomAPI = axios.create({
  baseURL: `${API_BASE_URL}/room`,
  timeout: Number(process.env.REACT_APP_API_TIMEOUT) || 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para manejo de errores específicos de habitaciones
roomAPI.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('Room Service Error:', error);
    return Promise.reject(error);
  }
);

// Servicios de habitaciones
export const roomService = {
  // Obtener todas las habitaciones completas (con imágenes)
  getAllRooms: async () => {
    try {
      const response = await roomAPI.get('/');
      return response.data;
    } catch (error) {
      throw new Error('Error al obtener las habitaciones: ' + error.message);
    }
  },

  // Obtener solo la información esencial para las cards
  getAllRoomsCards: async () => {
    try {
      const response = await roomAPI.get('/cards');
      return response.data;
    } catch (error) {
      throw new Error('Error al obtener las habitaciones para cards: ' + error.message);
    }
  },

  // Obtener habitaciones por tipo (HOTEL o GLAMPING)
  getRoomsByType: async (type) => {
    try {
      const response = await roomAPI.get(`/type/${type}`);
      return response.data;
    } catch (error) {
      throw new Error(`Error al obtener habitaciones de tipo ${type}: ` + error.message);
    }
  },

  // Obtener una habitación por ID
  getRoomById: async (id) => {
    try {
      const response = await roomAPI.get(`/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(`Error al obtener la habitación ${id}: ` + error.message);
    }
  },

  // Crear una nueva habitación (para admin)
  createRoom: async (roomData) => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await roomAPI.post('/', roomData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error al crear la habitación: ' + error.message);
    }
  },

  // Actualizar una habitación (para admin)
  updateRoom: async (id, roomData) => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await roomAPI.patch(`/${id}`, roomData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      throw new Error(`Error al actualizar la habitación ${id}: ` + error.message);
    }
  },

  // Eliminar una habitación (para admin)
  deleteRoom: async (id) => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await roomAPI.delete(`/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      throw new Error(`Error al eliminar la habitación ${id}: ` + error.message);
    }
  },
};

export default roomService;